function $q(ctx, selector, callback) {
  ctx.querySelectorAll(selector).forEach((el, index) => {
    callback(el, index, ctx)
  })
}

$q.first = function first(ctx, selector, callback) {
  const el = ctx.querySelector(selector)
  if (el) callback(el, 0, ctx)
}

// Cached query selector
function $cqs(selector, context = document) {
  // Check if the selector is already cached for this context
  if (!$cqs.cache) {
    // If not, create a cache object
    $cqs.cache = new WeakMap()
  }

  // Check if the selector is already in the cache for this context
  if (!$cqs.cache.has(context)) {
    $cqs.cache.set(context, new Map())
  }
  const cache = $cqs.cache.get(context)
  if (!cache.has(selector)) {
    // If not, query the DOM for the context and store the result in the cache
    cache.set(selector, context.querySelector(selector))
  }

  // Return the cached value
  return cache.get(selector)
}

const _HYDRATE_SKIP = Symbol('SKIP')
const FN_ATTR_EFFECTS_LOOKUP = {
  'x-show': (el, result) => {
    const show = !!result
    el.toggleAttribute('hidden', !show)
    // el.style.display = show ? '' : 'none'
  },
  'x-text': (el, result) => {
    el.textContent = result == null ? '' : result
  },
  'x-href': (el, result) => {
    el.setAttribute('href', result == null ? '' : result)
  },
  'x-effect': null,
}
const SUPPORTED_KEYS = Object.keys(FN_ATTR_EFFECTS_LOOKUP)

const _children_cache = new WeakMap()
export const hydrateFromHtml = ({
  elementTag,
  container,
  preferCachedChildren = true,
  // tuple of params and args
  context,
}) => {
  const fnAttrsLookup = FN_ATTR_EFFECTS_LOOKUP
  const data = context.reduce(
    (acc, tuple) => {
      acc.params.push(tuple[0])
      acc.args.push(tuple[1])
      return acc
    },
    { params: [], args: [] }
  )
  const isContainerFragment = container instanceof DocumentFragment

  let els = _children_cache.get(container)
  if (!els || !preferCachedChildren) {
    let selector = `${SUPPORTED_KEYS.map(x => `[${x}]`).join(', ')}`
    if (elementTag) {
      selector = `:is(${selector}):not([data-${elementTag}-excluded] *)`
    }
    els =  (isContainerFragment ? []  : [container]).concat(Array.from(container.querySelectorAll(selector)))
    _children_cache.set(container, els)
  }

  els.forEach(el => {
    const condFnString = el.getAttribute('x-if')
    if (condFnString) {
      const condFnCacheKey = `__fn_x-if`
      let condFn = el[condFnCacheKey]
      if (condFnString && !condFn) {
        condFn = new Function('$el', '$SKIP', '$cqs', ...data.params, `return (${condFnString})`)
        el[condFnCacheKey] = condFn
      }

      if (condFn) {
        const shouldContinue = condFn(el, _HYDRATE_SKIP, $cqs, ...data.args)
        if (!shouldContinue) return
      }
    }

    for (const fnAttr in fnAttrsLookup) {
      if (!Object.prototype.hasOwnProperty.call(fnAttrsLookup, fnAttr)) {
        continue
      }
      const condAttr = `${fnAttr}-if`

      const ourEffect = fnAttrsLookup[fnAttr]
      const userFnString = el.getAttribute(fnAttr)
      const condFnString = el.getAttribute(condAttr)

      if (!userFnString) {
        continue
      }

      const fnCacheKey = `__fn_${fnAttr}`
      const condFnCacheKey = `__fn_${condAttr}`

      let userFn = el[fnCacheKey]

      if (!userFn) {
        // if there is our effect, then we expect the `userFn` to be returnable
        const returnable = !!ourEffect
        const fnbody = returnable ? `return (${userFnString})` : userFnString
        userFn = new Function('$el', '$SKIP', '$cqs', ...data.params, fnbody)
        el[fnCacheKey] = userFn
      }

      let condFn = el[condFnCacheKey]
      if (condFnString && !condFn) {
        condFn = new Function('$el', '$SKIP', '$cqs', ...data.params, `return (${condFnString})`)
        el[condFnCacheKey] = condFn
      }

      try {
        if (condFn) {
          const shouldContinue = condFn(el, _HYDRATE_SKIP, $cqs, ...data.args)
          if (!shouldContinue) continue
        }

        // Run user fn
        const result = userFn(el, _HYDRATE_SKIP, $cqs, ...data.args)
        if (result === _HYDRATE_SKIP) continue

        // Run effect - if any
        if (ourEffect) {
          ourEffect(el, result)
        }
      } catch (e) {
        if (!el.hasAttribute('x-no-err')) {
          console.error('[hydrateFromHtml] :: ', e.message)
        }
      }
    }
  })
}

const $MS = (() => {var it=Object.defineProperty;var et=(t,r)=>{for(var i in r)it(t,i,{get:r[i],enumerable:!0})};var tt={};et(tt,{SCOPE:()=>n,computed:()=>X,createComputation:()=>g,createScope:()=>P,effect:()=>Z,getContext:()=>Y,getScope:()=>K,isFunction:()=>h,isNotEqual:()=>N,isReadSignal:()=>R,isWriteSignal:()=>d,onDispose:()=>E,onError:()=>B,peek:()=>W,readonly:()=>V,root:()=>M,scoped:()=>L,setContext:()=>z,signal:()=>U,tick:()=>H,untrack:()=>j});var n=Symbol(0);var x=!1,O=!1,s=null,a=null,f=null,l=0,o=[],A={},nt=()=>{},p=0,q=1,S=2,v=3;function st(){x=!0,queueMicrotask(F)}function F(){if(!o.length){x=!1;return}O=!0;for(let t=0;t<o.length;t++)o[t].$st!==p&&lt(o[t]);o=[],x=!1,O=!1}function lt(t){let r=[t];for(;t=t[n];)t.$e&&t.$st!==p&&r.push(t);for(let i=r.length-1;i>=0;i--)w(r[i])}function M(t){let r=P();return y(r,t.length?t.bind(null,$.bind(r)):t,null)}function W(t){return y(s,t,null)}function j(t){return y(null,t,null)}function H(){O||F()}function K(){return s}function L(t,r){try{return y(r,t,null)}catch(i){b(r,i);return}}function Y(t,r=s){return r?.$cx[t]}function z(t,r,i=s){i&&(i.$cx={...i.$cx,[t]:r})}function B(t){s&&(s.$eh=s.$eh?[t,...s.$eh]:[t])}function E(t){if(!t||!s)return t||nt;let r=s;return r.$d?Array.isArray(r.$d)?r.$d.push(t):r.$d=[r.$d,t]:r.$d=t,function(){r.$st!==v&&(t.call(null),h(r.$d)?r.$d=null:Array.isArray(r.$d)&&r.$d.splice(r.$d.indexOf(t),1))}}function $(t=!0){if(this.$st!==v){if(this.$h)if(Array.isArray(this.$h))for(let r=this.$h.length-1;r>=0;r--)$.call(this.$h[r]);else $.call(this.$h);if(t){let r=this[n];r&&(Array.isArray(r.$h)?r.$h.splice(r.$h.indexOf(this),1):r.$h=null),ut(this)}}}function ut(t){t.$st=v,t.$d&&G(t),t.$s&&C(t,0),t[n]=null,t.$s=null,t.$o=null,t.$h=null,t.$cx=A,t.$eh=null}function G(t){try{if(Array.isArray(t.$d))for(let r=t.$d.length-1;r>=0;r--){let i=t.$d[r];i.call(i)}else t.$d.call(t.$d);t.$d=null}catch(r){b(t,r)}}function y(t,r,i){let e=s,u=a;s=t,a=i;try{return r.call(t)}finally{s=e,a=u}}function b(t,r){if(!t||!t.$eh)throw r;let i=0,e=t.$eh.length,u=r;for(i=0;i<e;i++)try{t.$eh[i](u);break}catch(rt){u=rt}if(i===e)throw u}function m(){return this.$st===v?this.$v:(a&&!this.$e&&(!f&&a.$s&&a.$s[l]==this?l++:f?f.push(this):f=[this]),this.$c&&w(this),this.$v)}function k(t){let r=h(t)?t(this.$v):t;if(this.$ch(this.$v,r)&&(this.$v=r,this.$o))for(let i=0;i<this.$o.length;i++)Q(this.$o[i],S);return this.$v}var T=function(){this[n]=null,this.$h=null,s&&s.append(this)},c=T.prototype;c.$cx=A;c.$eh=null;c.$c=null;c.$d=null;c.append=function(t){t[n]=this,this.$h?Array.isArray(this.$h)?this.$h.push(t):this.$h=[this.$h,t]:this.$h=t,t.$cx=t.$cx===A?this.$cx:{...this.$cx,...t.$cx},this.$eh&&(t.$eh=t.$eh?[...t.$eh,...this.$eh]:this.$eh)};c.dispose=function(){$.call(this)};function P(){return new T}var J=function(r,i,e){T.call(this),this.$st=i?S:p,this.$i=!1,this.$e=!1,this.$s=null,this.$o=null,this.$v=r,i&&(this.$c=i),e&&e.dirty&&(this.$ch=e.dirty)},D=J.prototype;Object.setPrototypeOf(D,c);D.$ch=N;D.call=m;function g(t,r,i){return new J(t,r,i)}function N(t,r){return t!==r}function h(t){return typeof t=="function"}function w(t){if(t.$st===q)for(let r=0;r<t.$s.length&&(w(t.$s[r]),t.$st!==S);r++);t.$st===S?I(t):t.$st=p}function ft(t){t.$h&&$.call(t,!1),t.$d&&G(t),t.$eh=t[n]?t[n].$eh:null}function I(t){let r=f,i=l;f=null,l=0;try{ft(t);let e=y(t,t.$c,t);_(t),!t.$e&&t.$i?k.call(t,e):(t.$v=e,t.$i=!0)}catch(e){_(t),b(t,e)}finally{f=r,l=i,t.$st=p}}function _(t){if(f){if(t.$s&&C(t,l),t.$s&&l>0){t.$s.length=l+f.length;for(let i=0;i<f.length;i++)t.$s[l+i]=f[i]}else t.$s=f;let r;for(let i=l;i<t.$s.length;i++)r=t.$s[i],r.$o?r.$o.push(t):r.$o=[t]}else t.$s&&l<t.$s.length&&(C(t,l),t.$s.length=l)}function Q(t,r){if(!(t.$st>=r)&&(t.$e&&t.$st===p&&(o.push(t),x||st()),t.$st=r,t.$o))for(let i=0;i<t.$o.length;i++)Q(t.$o[i],q)}function C(t,r){let i,e;for(let u=r;u<t.$s.length;u++)i=t.$s[u],i.$o&&(e=i.$o.indexOf(t),i.$o[e]=i.$o[i.$o.length-1],i.$o.pop())}function U(t,r){let i=g(t,null,r),e=m.bind(i);return e[n]=!0,e.set=k.bind(i),e}function R(t){return h(t)&&n in t}function X(t,r){let i=g(r?.initial,t,r),e=m.bind(i);return e[n]=!0,e}function Z(t,r){let i=g(null,function(){let u=t();return h(u)&&E(u),null},void 0);return i.$e=!0,I(i),$.bind(i,!0)}function V(t){let r=()=>t();return r[n]=!0,r}function d(t){return R(t)&&"set"in t};return tt})();
window.$MS = $MS

// ---------------------------------------------------------------

// ---------------------------------------------------------------

// Do not remove or modify this
// class XThemeBaseElement extends HTMLElement{constructor(){super(),this._connected=!1,this._ac=null}async connectedCallback(){if(this._connected=!0,await Promise.resolve(),!this._connected)return;this._ac&&!this._ac.signal.aborted&&this._ac.abort(),this._ac=new AbortController;let t=this.mount();t instanceof Promise&&(t=await t),!1!==t&&this._aftermount()}mount(){}unmount(){}_aftermount(){this.setAttribute("hydrated","true")}_afterunmount(){this.setAttribute("hydrated","false")}async disconnectedCallback(){this._connected=!1,await Promise.resolve(),this._connected||(this._ac&&!this._ac.signal.aborted&&this._ac.abort(),this._ac=null,this.unmount(),this._afterunmount())}}

class XThemeBaseElement extends HTMLElement {
  constructor() {
    super()
    this._connected = false
    /** @type {AbortController} */
    this._ac = /** @type {any} */ (null)
    this._disposibles = []
  }

  async connectedCallback() {
    this.setAttribute('hydrated', 'false')

    this._connected = true
    await Promise.resolve()
    if (!this._connected) return

    this._ac && !this._ac.signal.aborted && this._ac.abort()
    this._ac = new AbortController()

    /** @type {any} */
    let x = this.mount()
    if (x instanceof Promise) {
      x = await x
    }

    if (x !== false) {
      this._aftermount()
    }
  }

  mount() {}
  unmount() {}

  /**
   * 
   * @param {() => void} cleanupFn 
   */
  onUnmount(cleanupFn) {
    this._disposibles.push(cleanupFn)
  }

  _aftermount() {
    this.setAttribute('hydrated', 'true')
  }
  _afterunmount() {
    this.setAttribute('hydrated', 'false')
  }

  async disconnectedCallback() {
    this._connected = false
    await Promise.resolve()
    if (this._connected) return

    this._ac && !this._ac.signal.aborted && this._ac.abort()
    // @ts-expect-error
    this._ac = null
    this.unmount()

    const disposables = this._disposibles.splice(0)
    for (let i = 0, l = disposables.length; i < l; i++) {
      disposables[i]?.()
    }

    this._afterunmount()
  }
}
window.XThemeBaseElement = XThemeBaseElement

/**
 *
 * @param {string} name
 * @param {(BaseElement: typeof XThemeBaseElement) => typeof XThemeBaseElement} cb
 */
export function customElementDefine(name, cb) {
  if (!window.customElements.get(name)) {
    window.customElements.define(name, cb(XThemeBaseElement))
  }
}
window.customElementDefine = customElementDefine

// ---------------------------------------------------------------

/*
;(() => {
  // get tomorrow's date by `getDateByDayOffset(new Date(), 1)`
  function getDateByDayOffset(date, offset = 1) {
    const next = new Date(date)
    next.setDate(next.getDate() + offset)
    return next
  }

  let weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  function getBusinessDay(from, days) {
    let result = new Date(from)

    for (let i = 0; i < days; i++) {
      result.setDate(result.getDate() + 1)

      const day = result.getDay()
      const saturday = day === 6
      const sunday = day === 0

      // If resulting day is saturday, then make it monday by adding 2 more days
      if (saturday) {
        result.setDate(result.getDate() + 2)
      } else if (sunday) {
        // If resulting day is sunday, then make it monday by adding 1 more day
        result.setDate(result.getDate() + 1)
      }
    }

    return result
  }

  function nth(n) {
    return n + (['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th')
  }

  function formatDate(date) {
    const weekdayName = weekdays[date.getDay()] // Monday
    const monthName = monthNames[date.getMonth()] // August
    const dayth = nth(date.getDate()) // 15th

    // Monday, August 15th
    return weekdayName + ', ' + monthName + ' ' + dayth
  }

  async function fetchGeoLocationAndTime() {
    let date = new Date()
    return fetch('https://accuair-geo.husseyexplores.workers.dev/api/geo').then(r => {
      if (r.headers.has('date')) {
        date = new Date(r.headers.get('date'))
      }
      return r.json()
    })
    .then(geo => ({ geo, date }))
  }

  function fetchCurrentTime() {
    return fetch('/cart.js').then(r => {
      if (r.headers.has('date')) {
        return new Date(r.headers.get('date'))
      }

      return fetch('https://time.akamai.com/?iso')
        .then(r => r.text())
        .then(dateString => new Date(dateString))
    })
  }

  class EstimatedDate extends HTMLElement {
    constructor() {
      super()
      this.$q = $q.bind(null, this)

      this._attrs = {}
      this._setValidatedAttrs = {
        min: (next) => {
          const num = parseInt(next, 10)

          if (!Number.isNaN(num)) {
            this.setAttribute('min', next)
            this._attrs.min = num
            this._calculateMinMaxDate('min')
            return num
          }
        },
        max: (next) => {
          const num = parseInt(next, 10)

          if (!Number.isNaN(num)) {
            this.setAttribute('max', next)
            this._attrs.max = num
            this._calculateMinMaxDate('max')
            return num
          }
        }
      }
    }

    static get observedAttributes() {
      return ['min', 'max']
    }

    attributeChangedCallback(attr, old, latest) {
      if (latest == null) {
        this.removeAttribute(attr)
        this._attrs[attr] = null
        return
      }
    }

    get min() {
      return this._attrs.min
    }

    set min(next) {
      return this._setValidatedAttrs.min(next)
    }

    get max() {
      return this._attrs.max
    }

    set max(next) {
      return this._setValidatedAttrs.max(next)
    }

    async connectedCallback() {
      this.removeAttribute('x-dehydrated')
      this._attrs = this._attrs || {}

      // consider `today` excluded (-1)
      this._todayUntilHours = Number(this.getAttribute('today-until') || '-1')
      this._calculateDateFrom = new Date()

      if (this.hasAttribute('from-api')) {
        const { geo, date } = await fetchGeoLocationAndTime()
        this._calculateDateFrom = date

        const international = geo?.country !== 'US'
        if (international) {
          const min = this.getAttribute('int-min')
          const max = this.getAttribute('int-max')
          if (min != null) this.setAttribute('min', min)
          if (max != null) this.setAttribute('max', max)
        }
      }

      this._attrs = {
        min: parseInt(this.getAttribute('min'), 10),
        max: parseInt(this.getAttribute('max'), 10)
      }

      this._calculateMinMaxDate('min')
      this._calculateMinMaxDate('max')
    }

    _calculateMinMaxDate(attr) {
      if (attr !== 'min' && attr !== 'max') {
        return
      }

      if (typeof this._attrs[attr] !== 'number') {
        return
      }

      if (Number.isNaN(this._attrs[attr])) {
        return
      }

      const estimatedDate = getBusinessDay(this._calculateDateFrom, this._attrs[attr])

      this.$q(
        `[data-${attr}]`,
        (el) => {
          el.textContent = formatDate(estimatedDate)
          if (el.tagName === 'TIME') {
            el.setAttribute('datetime', estimatedDate.toISOString())
          }
        },
        this
      )
    }

    _getCurrentHours(date) {
      if (!this.__dateFormatter) {
        const options = {
          timeZone: this.getAttribute('timezone-name') || 'America/Chicago',
          hour: 'numeric',
          hour12: false,
        }
        this.__dateFormatter = new Intl.DateTimeFormat([], options)
      }

      const currentHours = Number(this.__dateFormatter.format(date))
      return currentHours
    }

    get _calculateDateFrom() {
      return this.__calculateDateFrom
    }

    set _calculateDateFrom(date) {
      this.__calculateDateFrom = date
      const hours = this._getCurrentHours(date)

      // If past `todayUntilHours` (eg: 2PM / 14:00) - do not count the current day
      if (hours >= this._todayUntilHours) {
        this.__calculateDateFrom = getDateByDayOffset(this.__calculateDateFrom, 1)
      }
    }
  }

  if (!window.customElements.get('estimated-date')) {
    window.customElements.define('estimated-date', EstimatedDate)
  }

  // Dynamic Event Change Reactor
  class EventReactor extends XThemeBaseElement {
    mount() {
      this._listenFrom = this.getAttribute('listen-from')
      if (!this._listenFrom) {
        this.setAttribute('data-error-msg', 'Missing `listen-from` attribute')
        return
      }

      this._listenFrom =  document.getElementById(this._listenFrom)
      if (!this._listenFrom) {
        this.setAttribute('data-error-msg', 'Missing `listen-from` element in the DOM')
        return
      }

      this._dynamicChildren = this.hasAttribute('dynamic-childs')

      this._events = this.getAttribute('event')?.split(',').map(raw => {
        const [name, mappedTo = name] = raw.split('->')
        return { name, mappedTo: mappedTo.replace(/\:/g, '_') }
      })

      if (!Array.isArray(this._events) || this._events.length === 0) return

      if (this._events.length === 0) return

      this._stateContext = this._events.map((ev, index) => ([ev.mappedTo, null]))

      this._events.forEach((ev, index) => {
        this._listenFrom.addEventListener(ev.name, domEvent => {
          if (!this.isConnected) return

          this._stateContext[index][1] = domEvent.detail

          hydrateFromHtml({
            elementTag: 'event-reactor',
            container: this,
            preferCachedChildren: !this._dynamicChildren,
            context:  [
              // ['formatMoney', formatMoney],
              ['$event', domEvent],
              ['$detail', domEvent.detail],
              ...this._stateContext,
            ],
          })
        }, { signal: this._ac.signal })
      })

      this.removeAttribute('x-dehydrated')
    }

    unmount() {
      this._state = null
    }
  }

  if (!window.customElements.get("event-reactor")) {
    window.customElements.define("event-reactor", EventReactor)
  }
})();
*/

// ---------------------------------------------------------------

// ----------------------------------------------------------------------------------
async function jobRunner(job, { timeout = 5000, retries = 3 } = {}) {
  while (retries >= 0) {
    let ac = new AbortController();
    let timeoutId;
    let maxTimeout = timeout;
    try {
      timeoutId = setTimeout(() => ac.abort(), maxTimeout);

      const result = await job(ac.signal);
      clearTimeout(timeoutId);
      return result;
    } catch (e) {
      clearTimeout(timeoutId);
      if (e instanceof Error && e.name === 'AbortError') {
        if (retries > 0) {
          retries--;
          maxTimeout *= 1.2;
          continue; // Retry the job
        }

        throw e; // Return the AbortError after retries are exhausted
      }
      throw e; // Re-throw non-AbortError exceptions
    }
  }
}

/*
customElementDefine('x-product-card', XThemeBaseElement => {
  const parser = new DOMParser()
  return class XProductCard extends XThemeBaseElement {
    async mount() {
      let handle = (this.getAttribute('data-handle') || this.getAttribute('data-url'))?.split('?')[0].trim()
      if (handle) {
        const parts = handle.split('/')
        handle = parts[parts.length - 1]
      }

      if (!handle) {
        this.setAttribute('data-error-msg', 'Missing handle or url')
        return false
      }
      this.setAttribute('data-handle', handle)

      const htmlStr = await jobRunner(signal => fetch(`/search?type=product&q=handle:${handle}`, { signal: signal }).then(r => r.text()), { timeout: 15_000 })
      if (!this._connected) return
      const dom = parser.parseFromString(htmlStr, 'text/html')
      const card = dom.querySelector('product-card')
      if (card) {
        this.replaceWith(card)
      }
      requestAnimationFrame(() => {
        initLazyImages()
      })
    }

    unmount() {
      console.log('x-product-card unmounted')
    }
  }
})
*/

/*
customElementDefine('x-back-in-stock-form', XThemeBaseElement => {
  return class XBackInStockForm extends XThemeBaseElement {
    async mount() {
      const { klaviyoApi } = await import(this.getAttribute('data-klaviyo-module-asset-url'))

      let id = this.id
      if (!id) {
        // random id
        id = crypto.randomUUID()
        this.id = id
      }

      const formElements = [...this.querySelectorAll('[data-name]')].reduce((acc, item) => {
        const name = item.getAttribute('data-name')
        if (name) {
          acc.push(item)
        }
        return acc
      }, [])
      const submitBtns = [...this.querySelectorAll('button[type="submit"]')]

      const form_id = this.id + '_form'

      const form = document.createElement('form')
      form.setAttribute('id', form_id)

      for (let i = 0, l = formElements.length; i < l; i++) {
        const formElement = formElements[i]
        formElement.setAttribute('name', formElement.getAttribute('data-name') || '')
        formElement.setAttribute('form', form_id)
      }

      for (let i = 0, l = submitBtns.length; i < l; i++) {
        const submitBtn = submitBtns[i]
        submitBtn.setAttribute('form', form_id)
      }

      form.addEventListener('submit', async e => {
        e.preventDefault()

        let company_id = form.elements.namedItem('a').value
        const email = form.elements.namedItem('email').value
        const variant_id = form.elements.namedItem('variant_id').value
        if (!email || !variant_id || !company_id) return

        this.setAttribute('data-status', 'pending')

        const result = await klaviyoApi.backinstock({
          a: company_id,
          variant_id: Number(variant_id),
          attributes: {
            profile: {
              data: {
                attributes: {
                  email
                }
              }
            }
          }
        }).catch(e => {
          console.log('klaviyo caught error', e)
          return { ok: false, error: e }
        })

        this.setAttribute('data-status', result.ok ? 'idle success' : 'idle error')
        if (result.ok) {
          form.reset()
        }
      })

      document.body.appendChild(form)
    }

    unmount() {
      console.log('x-back-in-stock-form unmounted')
    }
  }
})
*/

// ----------------------------------------------------------------------------------

function domReady(fn) {
  if (document.readyState !== 'loading') {
    fn()
  } else {
    document.addEventListener('DOMContentLoaded', fn)
  }
}

/**
 * Wait for an element to be added to the DOM
 * then run the callback. Uses MutationObserver under the hood
 *
 * @param {string} selector
 * @param {(node: HTMLElement) => boolean} checkerFn
 * @param {(node: HTMLElement) => void} callback
 * @param {HTMLElement | Document} root
 * @returns {() => void} Function to unsubscribe the observer
 */
function waitForElement(selector, checkerFn, callback, root = document) {
  const element = root.querySelector(selector)
  if (element) {
    return void callback(element)
  }

  const observer = new MutationObserver((mutations, observer) => {
    for (let i = 0, l = mutations.length; i < l; i++) {
      const mutation = mutations[i]

      for (let j = 0, l2 = mutation.addedNodes; j < l2.length; j++) {
        const node = mutation.addedNodes[j]
        if (node instanceof HTMLElement && checkerFn(node) === true) {
          callback(node)
          observer.disconnect()
          return
        }
      }
    }

    // recheck
    const node = root.querySelector(selector)
    if (node) {
      callback(node)
      observer.disconnect()
      return
    }
  })

  observer.observe(root, { childList: true, subtree: true })
  return () => observer.disconnect()
}

async function tick() {
  return new Promise((resolve) => {
    requestAnimationFrame(resolve)
  })
}

function slugify(input, underscore = false) {
  // make lower case and trim
  let slug = input.toLowerCase().trim()

  // remove accents from charaters
  slug = slug.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

  // replace invalid chars with spaces
  slug = slug.replace(/[^a-z0-9\s-]/g, ' ').trim()

  // replace multiple spaces or hyphens with a single underscore
  slug = slug.replace(/[\s-]+/g, underscore ? '_' : '-')

  return slug
}

/**
 * Parses a CSV string into an array of objects.
 *
 * @template T - The expected type of parsed objects.
 * @param {string} csv - The CSV string to parse.
 * @param {Object} [options] - Parsing options.
 * @param {boolean} [options.header=true] - Whether the CSV has a header row.
 * @returns {Promise<Array<T>>} A promise that resolves to an array of parsed objects.
 */
function parseCsv(parse, csv, { header = true, transformHeader } = {}) {
  return new Promise((resolve, reject) => {
    parse(csv, {
      header,
      transformHeader: (header, index) => transformHeader?.(header, index, slugify) || slugify(header, true),
      complete: (results) => {
        if (!results) return reject(new Error('Missing results'));

        if (results.errors && results.errors.length > 0) {
          const error = new Error('Error parsing CSV. See console for details');
          error.errors = results.errors;

          console.log('CSV parsing errors', results.errors);
          return reject(error);
        }

        resolve(results.data);
      },
      error: reject,
    });
  });
}

const NOW = new Date()
/**
 * 
 * @param {*} x 
 */
function parseGsheetEventItem(x) {
  if (x.date) {
    let date = new Date(x.date)
    if (date.toString() === 'Invalid Date') {
      x.date = 'Invalid Date'
    } else {
      x.date = date 
    }
  }

  if (x.date instanceof Date) {
    // happening_status
    let happening_status = 'past'
    const eventEnded = x.date && NOW.getTime() > x.date.getTime()
    const futureEvent = x.date && NOW.getTime() < x.date.getTime()
    if (eventEnded) {
      happening_status = 'past'
    } else if (futureEvent) {
      happening_status = 'future'
    } else if (!eventEnded && !futureEvent) {
      happening_status = 'present'
    }
    x._happening_status = happening_status
  }

  return x
}

customElementDefine('x-events-widget', XThemeBaseElement => {
  return class XEventsWidget extends XThemeBaseElement {
    async mount() {
      const attrs = {
        id: 'id',
        gsheetGetUrl: this.getAttribute('gsheet-get-url'),
        gsheetConfigId: this.getAttribute('gsheet-config-id'),
        syncUrl:  this.getAttribute('sync-url') === 'true',
      }

      if (!attrs.gsheetGetUrl) {
        this.setAttribute('data-error-msg', 'Missing `gsheet-get-url` attribute')
        return
      }
      const itemTemplate = this.querySelector('template[data-template="item"]')
      if (!itemTemplate) {
        this.setAttribute('data-error-msg', 'Missing `<template data-template="item"></template>` element')
        return 
      }

      let maxItemsLimit = Math.round(Number(this.getAttribute('data-max-items-limit') || '0'))
      if (Number.isNaN(maxItemsLimit) || !Number.isFinite(maxItemsLimit) || maxItemsLimit < 0) maxItemsLimit = 0

      this.setAttribute('data-items-count', '0')
      this.setAttribute('data-rendered-items-count', '0')

      const { papa } = await import(window._theme_asset_url["papaparse.js"])
      if (typeof this.dataList === 'undefined') {
        this.setAttribute('data-fetch-status', 'pending')

        const csvText = await fetch(attrs.gsheetGetUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(r => r.text())
        if (!this._connected) return

        const dataList = await parseCsv(papa.parse, csvText, { header: true, transformHeader: (header, index) => header.toLowerCase().trim().startsWith('date output') ? 'date_output' : undefined })
        if (!this._connected) return
  
        this.dataList = {
          all: dataList || null,
          filtered: []
        }

        if (this.dataList.all) {
          this.setAttribute('data-fetch-status', 'idle success')

          for (let i = 0, l = this.dataList.all.length; i < l; i++) {
            const rawItem = this.dataList.all[i]
            const parsedItem = parseGsheetEventItem(rawItem)

            const hapStatus = parsedItem._happening_status
            if (!hapStatus || hapStatus !== 'past') {
              this.dataList.filtered.push(parsedItem)

              // limit items
              const len = this.dataList.filtered.length
              if (maxItemsLimit > 0 && maxItemsLimit == len) {
                break
              }
            }
          }
        } else {
          this.setAttribute('data-fetch-status', 'idle error')
        }
      }

      this.setAttribute('data-items-count', this.dataList.filtered.length.toString())
      this.setAttribute('data-rendered-items-count', this.dataList.filtered.length.toString())

      if (!this.dataList.filtered.length) return

      this.targetContainer = this;
      if (this.targetContainer === this) {
        let targetContainerId = this.getAttribute('data-target-container-id')
        if (targetContainerId) {
          const externalContainer = document.getElementById(targetContainerId)
          this.targetContainer = externalContainer || this    
        }
      }

      for (let i = 0, l = this.dataList.filtered.length; i < l; i++) {
        const itemJson  = this.dataList.filtered[i]
        // clone template and select the first child
        const itemNode = itemTemplate.content.cloneNode(true).querySelector('*')
        hydrateFromHtml({
          container: itemNode,
          context: [
            ['item', itemJson],
          ]
        })

        this.targetContainer.append(itemNode)
        this.onUnmount(() => {
          this.targetContainer.removeChild(itemNode)
        })
      }


      // external container
      if (this.targetContainer != this) {
        const childElementCount = this.targetContainer.childElementCount
        if (childElementCount > 0 && childElementCount % 4 === 0) {
          this.targetContainer.classList.add('with-4')
        }

        this.setAttribute('data-rendered-items-count', childElementCount)
      }
    }
  }
})